module.exports = __webpack_public_path__ + "static/img/28.6c77d2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/28.jpg
// module id = gKQJ
// module chunks = 1